import * as React from "react";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { Objects } from "../../../../../react-core/Utils/Objects";
import { InstructionStatus } from "../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { DrawdownType } from "../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import {
    AccountContextWizardComponent,
    IAccountContextWizardComponentState,
} from "../../../../Shared/Process/AccountContextWizardComponent";
import { Confirmation } from "../../../../Shared/Process/Process/Confirmation";
import { StepType } from "../../../../Shared/Process/Process/Process";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Contents } from "../../../Resoures/Contents";
import { Urls } from "../../../Urls";
import { RestrictionStore } from "../Common/Restrictions/Variable";
import { GadReviewAction } from "./Actions/GadReviewAction";
import { IncomePaymentDetails } from "./Components/IncomePaymentDetails/IncomePaymentDetails";
import { Review } from "./Components/Review/Review";
import { productMap, GadReviewSteppersMap, TextMessages } from "./Resource/Contents";
import { getDefaultModel } from "./Resource/Helper";
import { GadReviewInstructionStore } from "./Store/Variable";
interface IGadReviewWizardState extends IAccountContextWizardComponentState {
    extraInfo: any;
}
export class GadReviewWizard extends AccountContextWizardComponent<IGadReviewWizardState> {
    constructor(props: any) {
        super(props);
        this.subscribeToStore(GadReviewInstructionStore, () => this.onInstructionStoreChange());
    }

    onAccountRoleStoreChange() {
        super.onAccountRoleStoreChange();
        if (this.state.customer) {
            const id = getQueryParameters()["id"];
            const hierarchyId = getQueryParameters()["hierarchyid"];
            const subAccountHierarchyId = getQueryParameters()["subaccounthierarchyid"];
            if (!this.state.data) {
                if (id > 0) {
                    GadReviewAction.getInstruction(id, subAccountHierarchyId, this.state.customer.CustomerId);
                } else {
                    const defaultModel = getDefaultModel(hierarchyId, subAccountHierarchyId);
                    GadReviewAction.createInstruction(defaultModel, this.state.customer.CustomerId);
                }
            }
        }
    }

    initState() {
        this.state = {
            data: null,
            errorMsg: [],
            isShowErrorMsg: false,
            isLoading: true,
            onPosting: false,
            active: true,
            isSubmitting: false,
            customer: null,
            clientAccount: null,
            extraInfo: null,
        };
    }

    private onInstructionStoreChange() {
        if (GadReviewInstructionStore.getActionType() == ActionType.Success) {
            const data = GadReviewInstructionStore.getData();
            this.setState({
                isLoading: false,
                data: data,
                active:
                    data?.DrawdownIncomeAmendmentInstruction?.Status === InstructionStatus.Pending ||
                    data?.DrawdownIncomeAmendmentInstruction?.Status === InstructionStatus.NotSpecified,
            });
        }
    }

    componentDidMount() {
        super.componentDidMount();
        const hierarchyId = getQueryParameters()["hierarchyid"];
        GadReviewAction.getBankAccounts(hierarchyId, (result) => {
            this.setState({ extraInfo: { AllBankAccounts: result, Drawdowntype: DrawdownType.Capped } }); // To Update the Drawdowntypedetails
        });
    }

    saveInstruction(from, to, toUrl, params) {
        if (!params["id"]) {params["id"] = this.state.data?.DrawdownIncomeAmendmentInstruction?.Id;}
        GadReviewAction.saveInstruction(this.state.data, (result) => {
            this.setState({ onPosting: false });
            if (result.length > 0) {
                this.setState({ errorMsg: result, isShowErrorMsg: true });
            } else {
                if (to == -1) {
                    this.onExit();
                } else {
                    Navigator.navigateTo(toUrl, {
                        queryParamsObject: params,
                        scrollAfterNavigating: true,
                    });
                }
            }
        });
    }

    onCancel() {
        // GadReviewAction.deleteInstruction(this.state.data?.DrawdownIncomeAmendmentInstruction?.Id, () =>
        //     this.onExit()
        // );
        //SLP-70599
        this.onExit();
    }

    onExit() {
        const params = getQueryParameters();
        //TODO: navigate to customer dashboard
        // Navigator.navigateTo(Urls.get().main.ClientDashboard, {
        //     queryParamsObject: {
        //         hierarchyid: params["hierarchyid"],
        //     },
        //     scrollAfterNavigating: true,
        // });
    }

    onSubmit() {
        this.setState({ isSubmitting: true });
        const data = Objects.cloneObject(this.state.data);
        data.DrawdownIncomeAmendmentInstruction.Status = InstructionStatus.Submitted;
        GadReviewAction.submitInstruction(data, () => this.setState({ active: false, isSubmitting: false }));
    }

    getStepProps(index) {
        const { active } = this.state;
        const stepProps = super.getStepProps(index);
        stepProps.isReview = !active;

        if (!stepProps.isReview) {
            if (this.disableWithdraw()) {
                stepProps.isReview = true;
            }
        }
        return stepProps;
    }

    disableWithdraw() {
        const data = RestrictionStore.getData();
        if (RestrictionStore.WithdrawDisabled()) {
            if (getQueryParameters()["id"] > 0) {
                if (
                    this.state.data?.DrawdownIncomeAmendmentInstruction?.Income?.GrossIncomePerPayment?.Amount > 0 ||
                    this.state.data?.DrawdownIncomeAmendmentInstruction?.Income?.GrossIncomePerPaymentFromPension
                        ?.Amount
                ) {
                    return false;
                }
            } else {
                // disableWithdraw
                return true;
            }
        }
        return false;
    }

    private setReviewConfirmSteppers() {
        const type = Number(getQueryParameters()["type"]);
        const { data } = this.state;

        return [
            {
                title: GadReviewSteppersMap.review,
                url: Urls.get().GadReviewReview,
                path: Contents.URLMap.review,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                onSubmit: () => this.onSubmit(),
                canSubmit: () => this.child[1] && this.child[1].isValid(),
                component: <Review {...this.getStepProps(1)} type={type} extraInfo={this.state.extraInfo} />,
            },
            {
                title: GadReviewSteppersMap.comfirm,
                url: Urls.get().GadReviewConfiramation,
                path: Contents.URLMap.confirmation,
                type: StepType.Confirmation,
                component: (
                    <Confirmation
                        onExit={() => this.onExit()}
                        successMessage={TextMessages.successMessage(data)}
                        isLoading={this.state.isSubmitting}
                    />
                ),
            },
        ];
    }

    setStepperConfig() {
        const type = Number(getQueryParameters()["type"]);

        const steppers = [
            {
                title: GadReviewSteppersMap.incomePaymentDetails,
                url: Urls.get().GadReviewIncomePaymentDetails,
                path: Contents.URLMap.incomePayment,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <IncomePaymentDetails
                        {...this.getStepProps(0)}
                        disableWithdraw={this.disableWithdraw()}
                        type={type}
                        extraInfo={this.state.extraInfo}
                    />
                ),
            },
        ];
        this.stepperConfig = steppers;
        this.stepperConfig = this.stepperConfig.concat(this.setReviewConfirmSteppers());
    }

    setProcessProps() {
        const type = Number(getQueryParameters()["type"]);
        const { data } = this.state;
        const processProps = super.setProcessProps();
        processProps.processTitle = "GAD review";
        processProps.needSplitHeader = {
            fromStep: 0,
            splitHeaderMain: `${data?.ClientDetails?.PersonalDetails?.GivenName} ${data?.ClientDetails?.PersonalDetails?.FamilyName}`,
            splitHeaderSub: this.state.clientAccount?.HeadClAccountId,
        };
        processProps.subTitle = productMap[type];
        return processProps;
    }
}
